(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["two-image-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeSlider = (slider) => {
      if (slider.dataset.initialized === 'true') return;
      slider.dataset.initialized = 'true';

      const track = slider.querySelector('.two-image-slider__track');
      const slides = Array.from(slider.querySelectorAll('[data-slide]'));
      const previous = slider.querySelector('[data-slider-previous]');
      const next = slider.querySelector('[data-slider-next]');
      const dots = Array.from(slider.querySelectorAll('[data-slider-dot]'));

      if (!track || slides.length < 2) return;

      let currentIndex = 0;
      let autoplayTimer;
      let touchStartX = 0;

      const showSlide = (index) => {
        currentIndex = (index + slides.length) % slides.length;
        track.style.transform = `translateX(-${currentIndex * 100}%)`;

        slides.forEach((slide, slideIndex) => {
          slide.setAttribute('aria-hidden', String(slideIndex !== currentIndex));
        });

        dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === currentIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-selected', String(isActive));
        });
      };

      const stopAutoplay = () => window.clearInterval(autoplayTimer);
      const startAutoplay = () => {
        stopAutoplay();
        if (
          slider.dataset.autoplay === 'true' &&
          !window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ) {
          autoplayTimer = window.setInterval(
            () => showSlide(currentIndex + 1),
            Number(slider.dataset.autoplaySpeed)
          );
        }
      };

      previous?.addEventListener('click', () => {
        showSlide(currentIndex - 1);
        startAutoplay();
      });

      next?.addEventListener('click', () => {
        showSlide(currentIndex + 1);
        startAutoplay();
      });

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          showSlide(Number(dot.dataset.sliderDot));
          startAutoplay();
        });
      });

      slider.addEventListener('mouseenter', stopAutoplay);
      slider.addEventListener('mouseleave', startAutoplay);
      slider.addEventListener('focusin', stopAutoplay);
      slider.addEventListener('focusout', startAutoplay);

      slider.addEventListener(
        'touchstart',
        (event) => {
          touchStartX = event.changedTouches[0].clientX;
          stopAutoplay();
        },
        { passive: true }
      );

      slider.addEventListener(
        'touchend',
        (event) => {
          const distance = event.changedTouches[0].clientX - touchStartX;
          if (Math.abs(distance) > 50) {
            showSlide(currentIndex + (distance < 0 ? 1 : -1));
          }
          startAutoplay();
        },
        { passive: true }
      );

      slider.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') showSlide(currentIndex - 1);
        if (event.key === 'ArrowRight') showSlide(currentIndex + 1);
      });

      startAutoplay();
    };

    document.querySelectorAll('[data-two-image-slider]').forEach(initializeSlider);

    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-two-image-slider]').forEach(initializeSlider);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
